var t = class extends HTMLElement {
	constructor() {
		super(), this.initWebComponent();
	}
	initWebComponent() {
		const t = this.attachShadow({
			mode: "open",
			clonable: !0,
			serializable: !0
		}), i = document.createElement("template");
		i.innerHTML = "<style>:host{--gap:var(--jb-notification-wrapper-gap,.5rem);--width:var(--jb-notification-wrapper-width,100vw);--height:var(--jb-notification-wrapper-height,100vh);--padding-top:var(--jb-notification-wrapper-padding-top,4rem);--z-index:var(--jb-notification-wrapper-z-index,9999);--top:var(--jb-notification-wrapper-top,0);--left:var(--jb-notification-wrapper-left,0);--position:var(--jb-notification-wrapper-position,absolute);--overflow:var(--jb-notification-wrapper-overflow,hidden);--display:var(--jb-notification-wrapper-display,flex);--align-items:var(--jb-notification-wrapper-align-items,center);--flex-direction:var(--jb-notification-wrapper-flex-direction,column);--pointer-events:var(--jb-notification-wrapper-pointer-events,none)} .jb-notification-wrapper-web-component{position:var(--position);box-sizing:border-box;overflow:var(--overflow);display:var(--display);align-items:var(--align-items);flex-direction:var(--flex-direction);gap:var(--gap);width:var(--width);height:var(--height);padding-top:var(--padding-top);z-index:var(--z-index);top:var(--top);left:var(--left);pointer-events:var(--pointer-events)}</style>\n\n  <div class=\"jb-notification-wrapper-web-component\">\n    <slot></slot>\n  </div>\n  ", t.appendChild(i.content.cloneNode(!0));
	}
	static get observedAttributes() {
		return ["x-position", "y-position"];
	}
	attributeChangedCallback(t, i, e) {
		this.onAttributeChange(t, e);
	}
	onAttributeChange(t, i) {}
};
customElements.get("jb-notification-wrapper") || window.customElements.define("jb-notification-wrapper", t);
export { t as JBNotificationWrapperWebComponent };

//# sourceMappingURL=jb-notification-wrapper.js.map